import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "warning"]
  static values = {
    current: String
  }

  connect() {
    this.hideWarning()
  }

  change() {
    const newValue = this.selectTarget.value
    if (newValue === this.currentValue) {
      this.hideWarning()
      return
    }

    let message = ""
    if (this.currentValue === "legacy" && newValue === "blocks") {
      message = "This will create a single HTML block from the existing content. This is reversible."
    } else if (this.currentValue === "blocks" && newValue === "legacy") {
      message = "This will compile all blocks into HTML and DELETE all content blocks. This is not easily undone."
    }

    if (message) {
      this.warningTarget.textContent = message
      this.warningTarget.classList.remove("hidden")
    } else {
      this.hideWarning()
    }
  }

  hideWarning() {
    if (this.hasWarningTarget) {
      this.warningTarget.classList.add("hidden")
    }
  }
}
